
import { mapState } from 'vuex'
import tailwindConfig from '@/tailwind.config.js'
import { cdnPath, cdnPathWebP } from '@/utils/constants'
export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      carouselOptions: {
        slidesToShow: 1,
        lazyLoad: 'ondemand',
        arrows: false,
        dots: true,
        dotsClass: 'image-carousel__dots',
        swipe: true,
      },
      tablet: parseInt(tailwindConfig.theme.screens.tablet, 10),
      desktopMd: parseInt(tailwindConfig.theme.screens['desktop-md'], 10),
    }
  },
  computed: {
    ...mapState(['cdn']),
  },
  methods: {
    cdnPath,
    cdnPathWebP,
    beforeImageChange() {
      this.$emit('image-changed')
    },
    preventDrag(event) {
      event.preventDefault()
    },
  },
}
